import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ResizableAudio from '../components/ResizableAudio';

export const AudioNode = Node.create({
  name: 'audioNode',
  
  group: 'block',

  atom: true,

  draggable: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
      controls: {
        default: true,
      },
      width: {
        default: '400px',
      },
      height: {
        default: 'auto',
      },
      transcript: {
        default: null,
      },
      transcriptSharedWithStudent: {
        default: false,
        // Content round-trips through HTML strings (editor.getHTML()/
        // setContent), not JSON — the default attribute handling would
        // serialize `false` as the string "false" and then parse it back
        // via getAttribute(), which is truthy. Convert explicitly.
        parseHTML: element => element.getAttribute('transcriptsharedwithstudent') === 'true',
        renderHTML: attributes => ({
          transcriptsharedwithstudent: attributes.transcriptSharedWithStudent ? 'true' : 'false',
        }),
      },

    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'div[data-type="audio"]',
      },
      {
        tag: 'audio',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    // Если это base64 аудио, создаем div с data-type="audio"
    if (HTMLAttributes.src && HTMLAttributes.src.startsWith('data:audio/')) {
      return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'audio' })];
    }
    // Для обычных аудио файлов
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'audio' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(ResizableAudio);
  },
  
  addCommands() {
    return {
      insertAudio: (attributes) => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: attributes,
        });
      },
    };
  },
}); 